import { render, staticRenderFns } from "./MergeForm.vue?vue&type=template&id=70c36780&scoped=true"
import script from "./MergeForm.vue?vue&type=script&lang=js"
export * from "./MergeForm.vue?vue&type=script&lang=js"
import style0 from "./MergeForm.vue?vue&type=style&index=0&id=70c36780&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c36780",
  null
  
)

export default component.exports